export enum CivilStatus {
    Single = 1,
    Married = 2,
    Widower = 3,
    Divorced = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/CivilStatus.ts